import React, { FC } from 'react';
import Styles from './TVChannelModal.module.scss';
import { Modal } from 'react-bootstrap';
import RichText from '../richtext';
import { AssetPathPropConfig } from '../../services/LineTableBasicPropConfig';

const TVChannelModal: FC<any> = ({ content, setShowModal, showModal, constants }) => {
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();

  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <Modal
      contentClassName={Styles.errormodalbox}
      show={showModal}
      dialogClassName={Styles.errordialog}
      onHide={closeModal}
      centered
    >
      <Modal.Header className={Styles.header} closeButton onClick={closeModal} />
      <div className={Styles.errorwrapper}>
        <Modal.Title className={Styles.title}>{content?.modalHeadline}</Modal.Title>
      </div>

      <Modal.Body className={Styles.body}>
        <div className={Styles.bodywrapper}>
          <div className={Styles.cardwrapper}>
            <h4>{content?.modalTitle}</h4>
            <div className='mb-3'>
              <RichText content={content?.modalDescription} />
            </div>
            <div className={`row w-100 pt-2 mt-auto`}>
              <h3 className='col-9 mb-0'>{constants?.includedTxt}</h3>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className={Styles.footer}>
        <div className='row w-100'>
          <div className='text-center'>
            <button className={`${Styles.confirmBtn}  primarybutton`} onClick={() => closeModal}>
              {constants?.closeTxt}
              <img
                className={Styles['img-tick']}
                src={`${assetPath}/icons/tick.svg`}
                height={24}
                width={24}
                alt={''}
              />
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TVChannelModal;
